










import Vue, { PropType } from 'vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import { Breadcrumb } from '~/models/common/types'

export default Vue.extend({
  components: { CBreadcrumbs },
  props: {
    breadcrumbs: {
      type: Array as PropType<Breadcrumb[]>,
      default() {
        return []
      }
    },
    nuxtLinks: {
      type: Boolean,
      default: false
    }
  }
})
